import * as React from 'react';
import loc, { formatToArray } from 'owa-localize';
import { roomBookingContent } from './RoomBookingAssistant.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from '@fluentui/react/lib/Button';
import { CalendarEvent } from 'owa-calendar-types';
import { getDay } from 'owa-datetime';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { LazyRoomPreferenceRow } from 'owa-calendar-room-preferences-option';
import generateDefaultDropdownStyles from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateDefaultDropdownStyles';
import generateDropdownCalloutStyles from 'owa-component-styling-utils/lib/utils/generateDropdownCalloutStyles';
import { IStyle } from '@uifabric/styling';

const styles = require('./FullComposeLeftPane.scss');

export interface RoomBookingAssistantContentProps {
    event: CalendarEvent;
    colorScheme: ColorScheme;
    onClick: () => void;
}

const RoomBookingAssistantContent = (props: RoomBookingAssistantContentProps) => {
    const { event, colorScheme, onClick } = props;

    const currentDay = getDay(event.Start);

    const titleStyle: IStyle = [
        {
            borderWidth: '0px',
            backgroundColor: 'transparent',
            color: colorScheme.calPrimary + '!important', // override Fabric color when title is placeHolder
            paddingLeft: '1px',
            paddingRight: '1px',
            height: '20px',
            lineHeight: '18px',
            selectors: {
                '&:hover': {
                    color: colorScheme.calDarker + '!important', // override the above !important statement when being hovered
                },
            },
        },
    ];

    const dropdownStylesOverride = {
        dropdownItemStyle: {
            paddingLeft: '12px',
            height: '48px',
            width: '300px',
            display: 'block',
        },
    };

    let dropdownStyles = generateDefaultDropdownStyles(colorScheme, dropdownStylesOverride);
    dropdownStyles.title = titleStyle;

    const calloutProps = {
        styles: generateDropdownCalloutStyles(),
        gapSpace: 5,
        calloutMaxHeight: 300,
    };

    const roomPreferenceOptions = (
        <div className={styles.roomPreferenceOptions}>
            <LazyRoomPreferenceRow
                day={currentDay}
                colorScheme={colorScheme}
                calloutProps={calloutProps}
                dropdownStyles={dropdownStyles}
                isCompactMode={true}
                immediatelySave={true}
            />
        </div>
    );

    return (
        <div className={styles.roomBookingAssistantContainer}>
            <div className={styles.roomBookingAssistantContent}>
                <span>{formatToArray(loc(roomBookingContent), roomPreferenceOptions)}</span>
            </div>
            <IconButton
                className={styles.roomBookingAssistantCloseButton}
                iconProps={{ iconName: ControlIcons.Cancel }}
                onClick={onClick}
            />
        </div>
    );
};

export default RoomBookingAssistantContent;
